import { Modal, ModalBody } from "@aurem/ui";
import { useTranslations } from "../i18n";
import { MfaCodeInputForm, PasswordConfirmationForm } from "../mfa";
import { EmailOtpModalBody } from "./EmailOtpModal";
import { ReauthenticationDialogProps } from "./types";

export const ReauthenticationDialog = ({
  type,
  onSuccess,
  errorMessage,
  actionType,
  handleSendEmailOtp,
  resendCountdown,
  ...modalProps
}: ReauthenticationDialogProps) => {
  const { t } = useTranslations();
  const handleClose = () => modalProps.onOpenChange(false);

  if (type === "mfa") {
    return (
      <Modal {...modalProps}>
        {modalProps.open && (
          <ModalBody className="p-8">
            <MfaCodeInputForm
              mode="reauthentication"
              onSuccess={onSuccess}
              onClose={handleClose}
              errorMessage={errorMessage}
            />
          </ModalBody>
        )}
      </Modal>
    );
  }

  if (type === "password") {
    return (
      <Modal
        {...modalProps}
        title={t("apps.employee.reauthentication.password.heading")}
        description={t("apps.employee.reauthentication.password.description")}
      >
        {modalProps.open && (
          <ModalBody>
            <PasswordConfirmationForm
              mode="reauthentication"
              onClose={handleClose}
              onSuccess={onSuccess}
              errorMessage={errorMessage}
            />
          </ModalBody>
        )}
      </Modal>
    );
  }

  return (
    <Modal
      {...modalProps}
      title={t("apps.employee.emailOtp.title")}
      description={t("apps.employee.emailOtp.description")}
    >
      <EmailOtpModalBody
        onSuccess={onSuccess}
        onClose={handleClose}
        errorMessage={errorMessage}
        handleSendEmailOtp={handleSendEmailOtp}
        resendCountdown={resendCountdown}
      />
    </Modal>
  );
};
